var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, ButtonVariant } from '@patternfly/react-core';
import { CloseIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
const useStyles = createUseStyles({
    closeButton: {
        float: 'inline-end',
        padding: '10px 14px'
    },
});
;
const CloseButton = (_a) => {
    var { className, dataTestID, onClick } = _a, props = __rest(_a, ["className", "dataTestID", "onClick"]);
    const classes = useStyles();
    return (React.createElement(Button, Object.assign({ "aria-label": props['aria-label'] || 'Close', className: clsx(classes.closeButton, className), "data-test-id": dataTestID, onClick: onClick, variant: ButtonVariant.plain }, props),
        React.createElement(CloseIcon, null)));
};
export default CloseButton;
